import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  addHorseToTrackPopup: {
    "& .MuiDialogTitle-root": {
      paddingTop: 40,
      paddingBottom: 25,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        padding: "16px 22px"
      }
    }
  }
}));
